import { create } from 'zustand';

type StakeholderPoolItem = {
  poolId: string;
  stakeholderId: string;
};

type SelectedStakeholderState = {
  stakeholderId: string[];
  stakeholderPoolId: StakeholderPoolItem[];
};

type SelectedPoolState = {
  planId: string[];
  poolId: string[];
};

type SelectedPoolStore = {
  deselectPlan: (id: string) => void;
  deselectPool: (id: string) => void;
  deselectStakeholder: (id: string) => void;
  deselectStakeholderPool: (stakeholderId: string, poolId: string) => void;
  poolState: SelectedPoolState;
  resetPoolState: () => void;
  resetStakeholderState: () => void;
  setSelectedPlan: (id: string) => void;
  setSelectedPool: (id: string) => void;
  setSelectedStakeholder: (id: string) => void;
  setSelectedStakeholderPool: (stakeholderId: string, poolId: string) => void;
  stakeholderState: SelectedStakeholderState;
};

export const useSelectedPoolsStore = create<SelectedPoolStore>((set) => ({
  stakeholderState: {
    stakeholderId: [],
    stakeholderPoolId: [],
  },
  setSelectedStakeholder: (id) =>
    set((store) => ({
      stakeholderState: {
        ...store.stakeholderState,
        stakeholderId: [...store.stakeholderState.stakeholderId, id],
      },
    })),

  deselectStakeholder: (id) =>
    set((store) => ({
      stakeholderState: {
        ...store.stakeholderState,
        stakeholderId: store.stakeholderState.stakeholderId.filter((sid) => sid !== id),
        stakeholderPoolId: store.stakeholderState.stakeholderPoolId.filter(
          (item) => item.stakeholderId !== id,
        ),
      },
    })),

  setSelectedStakeholderPool: (stakeholderId, poolId) =>
    set((store) => ({
      stakeholderState: {
        ...store.stakeholderState,
        stakeholderPoolId: [...store.stakeholderState.stakeholderPoolId, { stakeholderId, poolId }],
      },
    })),

  deselectStakeholderPool: (stakeholderId, poolId) =>
    set((store) => ({
      stakeholderState: {
        ...store.stakeholderState,
        stakeholderPoolId: store.stakeholderState.stakeholderPoolId.filter(
          (item) => item.stakeholderId !== stakeholderId || item.poolId !== poolId,
        ),
      },
    })),

  resetStakeholderState: () =>
    set(() => ({
      stakeholderState: {
        stakeholderId: [],
        stakeholderPoolId: [],
      },
    })),

  poolState: {
    poolId: [],
    planId: [],
  },
  setSelectedPool: (id) =>
    set((store) => ({
      poolState: {
        ...store.poolState,
        poolId: [...store.poolState.poolId, id],
      },
    })),

  deselectPool: (id) =>
    set((store) => ({
      poolState: {
        ...store.poolState,
        poolId: store.poolState.poolId.filter((pid) => pid !== id),
      },
    })),

  setSelectedPlan: (id) =>
    set((store) => ({
      poolState: {
        ...store.poolState,
        planId: [...store.poolState.planId, id],
      },
    })),

  deselectPlan: (id) =>
    set((store) => ({
      poolState: {
        ...store.poolState,
        planId: store.poolState.planId.filter((pid) => pid !== id),
      },
    })),

  resetPoolState: () =>
    set(() => ({
      poolState: {
        poolId: [],
        planId: [],
      },
    })),
}));
